const { REACT_APP_API_PREFIX_DEV, REACT_APP_API_PREFIX_PROD, NODE_ENV } = process.env;

export const API_PREFIX =
  NODE_ENV === 'production' ? REACT_APP_API_PREFIX_PROD : REACT_APP_API_PREFIX_DEV;

export const defaultUserImage = '/images/default-user-icon.jpg';
